module.exports = __webpack_public_path__ + "img/image02.4bb36944.jpg";